export enum CHART_TYPES {
  METRIC_CHART = 'NUMBER',
  LINE_CHART = 'LINE',
  PIE_CHART = 'PIE',
  BAR_CHART = 'BAR',
  STACKED_COLUMN_CHART = 'STACKED_COLUMN',
  PERCENT_STACKED_AREA_CHART = 'PERCENT_STACKED_AREA',
  FUNNEL_CHART = 'FUNNEL',
  COMPARATIVE_LINE_CHART = 'COMPARATIVE_LINE',
  PATH = 'PATH',
  RETENTION = 'RETENTION',
  RETENTION_LINE = 'RETENTION_LINE',
  RETENTION_BAR = 'RETENTION_BAR',
  PREDICTION = 'PREDICTION',
  COHORT_SAMPLE = 'COHORT_SAMPLE',
  DATA_TABLE = 'DATA_TABLE',
  EXPRESSION_TABLE = 'EXPRESSION_TABLE',
  SIGNIFICANCE = 'SIGNIFICANCE',
  GEO_MAP = 'GEO',
}

export const chartTypesAllowIncidents = [
  CHART_TYPES.LINE_CHART,
  CHART_TYPES.PERCENT_STACKED_AREA_CHART,
  CHART_TYPES.STACKED_COLUMN_CHART,
  CHART_TYPES.BAR_CHART,
  CHART_TYPES.FUNNEL_CHART,
  CHART_TYPES.COMPARATIVE_LINE_CHART,
];
